export default __webpack_public_path__ + "static/media/bg-pes-2.d65548c5.png";